import { Component, OnInit, AfterViewInit } from '@angular/core'
import { Router } from '@angular/router'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'

import { LoaderService } from '@core/components/loaders/services/loader.service'
import { selectPageLoading } from '@app/core/store'
import { AuthManagerService } from '@services/auth/auth-manager.service'
import { logOut } from '@auth/store/actions/auth.actions'
import { State, errorMessageSelector } from '@auth/store/reducers/auth.reducers'
/**
 * Component that handles the user authentication and logout
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, AfterViewInit {
  /**
   * The Form Builder
   */
  form: FormGroup
  /**
   * The selector of the `loading` state property, it displays a mask when receiving a `true` boolean value
   */
  loading$: Observable<boolean>
  /**
   * The error messages observable
   */
  loginErrorMsg$: Observable<string>
  /**
   */
  resetPassword: boolean

  /**
   * Default contructor
   * @param {object} formBuilder
   * @param {object} authManager
   * @param {object} loaderService
   * @param {object} router
   * @param {object} store
   */
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthManagerService,
    private router: Router,
    private loaderService: LoaderService,
    private store: Store<State>
  ) {}
  /**
   * Initializes the form and selects/ listens to the changes of some properties stored in the state
   */
  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    })
    this.loginErrorMsg$ = this.store.select(errorMessageSelector)
    this.loading$ = this.store.select(selectPageLoading, {
      feature: 'Auth',
    })
  }
  /***
   * Adds a styleName to the ROOT HTML element
   */
  ngAfterViewInit() {
    ;(document.querySelector('html') as HTMLElement).className = 'login'
  }
  /**
   *  Submits the form data
   */
  onSubmit(): void {
    this.router.navigate(['/'])
  }
  
  onResetSuccess(event) {
    if (event) {
      this.resetPassword = false
     // this.store.dispatch(logOut({}))
    }
  }
  
  changePassword(): void {
    this.resetPassword = true
  }
}
